import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { axiosInstance } from "../../Config";

const ViewMatch = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const [error, setError] = useState("");
    const [match, setMatch] = useState(location.state?.match || null);
    const [loading, setLoading] = useState(!location.state?.match);

    useEffect(() => {
        if (location.state?.match) return;

    }, [id]);


    const getStatusText = (status) => {
        if (status === 0) return "Pending";
        if (status === 1) return "Ongoing";
        if (status === 2) return "Ended";
        return "N/A";
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
    };

    if (loading) {
        return (
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="layout-wrapper">
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="title-box mb-3 pb-1">
                            <h4 className="mb-0 page-title">Match Details</h4>
                            <nav aria-label="breadcrumb" className="mt-1">
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard" className="new">
                                            <i className="ri-home-4-fill me-1" /> Home
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/matchlist" className="new">
                                             Matches
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        View Match
                                    </li>
                                </ol>
                            </nav>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        {error && (
                                            <div className="alert alert-danger" role="alert">
                                                {error}
                                            </div>
                                        )}

                                        {match ? (
                                            <div className="row">


                                                <h5 className="mb-3">User 1</h5>
                                                <div className="col-md-6 mb-3">
                                                    <label className="fw-bold text-muted mb-1">Name</label>
                                                    <div className="p-2 bg-light rounded">{match?.user1?.name || "N/A"}</div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="fw-bold text-muted mb-1">Email</label>
                                                    <div className="p-2 bg-light rounded">{match?.user1?.email || "N/A"}</div>
                                                </div>

                                                <hr className="my-3" />

                                                <h5 className="mb-3">User 2</h5>
                                                <div className="col-md-6 mb-3">
                                                    <label className="fw-bold text-muted mb-1">Name</label>
                                                    <div className="p-2 bg-light rounded">{match?.user2?.name || "N/A"}</div>
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="fw-bold text-muted mb-1">Email</label>
                                                    <div className="p-2 bg-light rounded">{match?.user2?.email || "N/A"}</div>
                                                </div>

                                                <hr className="my-3" />

                                                <div className="col-md-6 mb-3">
                                                    <label className="fw-bold text-muted mb-1">Status</label>
                                                    <div className="p-2 bg-light rounded">{getStatusText(match.status)}</div>
                                                </div>

                                                <div className="text-end mt-4">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary me-2 px-4"
                                                        onClick={() => navigate("/matchlist")}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            !error && (
                                                <div className="text-center py-4">
                                                    <p>No match details found</p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary mt-3"
                                                        onClick={() => navigate("/matchlist")}
                                                    >
                                                        Back to List
                                                    </button>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewMatch;